import { FeedbackModal } from '@cabonline/ui-web';
import styled from '@emotion/styled';
import { CheckCircleOutlineRounded, WarningAmber } from '@mui/icons-material';
import React from 'react';

import { FeedbackAnnouncementProps, FeedbackModalWrapperProps, FeedbackType } from './types';

export const StyledSuccessIcon = styled(CheckCircleOutlineRounded, {
  shouldForwardProp: (prop) => prop !== 'iconSize',
})<{ iconSize: string }>`
  width: ${(p) => p.iconSize};
  height: ${(p) => p.iconSize};
`;

export const StyledErrorIcon = styled(WarningAmber, {
  shouldForwardProp: (prop) => prop !== 'iconSize',
})<{ iconSize: string }>`
  width: ${(p) => p.iconSize};
  height: ${(p) => p.iconSize};
`;

export const VisuallyHidden = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const getIcon = (type: FeedbackType, isDesktop: boolean): React.ReactElement | undefined => {
  const iconSize = isDesktop ? '40px' : '32px';

  switch (type) {
    case 'success': {
      return <StyledSuccessIcon iconSize={iconSize} />;
    }
    case 'error': {
      return <StyledErrorIcon iconSize={iconSize} />;
    }
    default:
      return undefined;
  }
};

export const FeedbackAnnouncement: React.FC<FeedbackAnnouncementProps> = ({ data }) => {
  const isError = data?.type === 'error';

  return (
    <VisuallyHidden
      role={isError ? 'alert' : 'status'}
      aria-live={isError ? 'assertive' : 'polite'}
      aria-atomic="true"
    >
      {data && (
        <>
          {data.title}
          {typeof data.text === 'string' ? ` ${data.text}` : null}
        </>
      )}
    </VisuallyHidden>
  );
};

export const FeedbackModalWrapper: React.FC<FeedbackModalWrapperProps> = ({
  data,
  isAnyModalOpen,
  deviceType,
  closeButtonLabel,
}) => {
  if (!data) return null;

  return (
    <FeedbackModal
      {...data}
      isSecondaryModal={isAnyModalOpen}
      closeButtonLabel={data.closeButtonLabel || closeButtonLabel}
      icon={data.icon || getIcon(data.type, deviceType === 'desktop')}
      isDesktop={deviceType === 'desktop'}
    />
  );
};
